import styled, { css } from "styled-components";
import { Flex } from "../division";
import Div from "../division";

const filterStyleOnlyProps = new Set(["showoptions", "disableFilter"]);
const shouldForwardFilterProp = prop => !filterStyleOnlyProps.has(prop);

export const CustomImageWrapper = styled.img.withConfig({
  shouldForwardProp: shouldForwardFilterProp,
})`
border: ${props =>props.disableFilter ? "1px solid #e3e3e3" : ""};
background-color:  ${props =>props.disableFilter ? "#ededed" : ""};
cursor: ${props =>props.disableFilter ? "not-allowed" : "pointer"} !important;
`

export const FilterWrapper = styled.div.withConfig({
  shouldForwardProp: shouldForwardFilterProp,
})`
  position: relative;
  & > img {
    height: 30px;
    width: 30px;
    padding: 5px;
    border: 1px solid #dfdfdf;
    background-color: ${props => props.showoptions ? props.theme.lightBlue : ""};
  }
  section{
    z-index: 9999;
    cursor: pointer;
    justify-content: space-between;
    margin-top: -7px;
    display: flex;
    flex-direction: row;
    width: 190px;
    padding: 8px 5px 8px 15px;
    gap: 10px;
    border: 1px solid #999999;
    background-color: white;
    font-weight: 500;
    color: #616161;
    text-transform: capitalize;
  }
`;

export const Options = styled(Div)`
  position: absolute;
  max-height: 208px;
  padding: 20px;
  overflow-y: scroll;
  left: ${props => props.leftCssValue};
  top: 31px;
  box-sizing: border-box;
  height: auto;
  width: 190px;
  border: 1px solid ${props => props.theme.greyLight};
  background-color: ${props => props.theme.brandWhite};
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  z-index: 2;
  justify-content: flex-start;
`;

export const Option = styled(Flex)`
  align-items: center;
  & > div:first-child {
    margin-right: 10px;
  }
  & > div:last-child {
    line-height: 4px;
    cursor: pointer;
  }
`;
